export default __webpack_public_path__ + "static/logo-c2a01470bacbf0ffc9a784885c1e8249.svg";